import type { ObservationLite } from "@/entities/observation";

import { useTranslation } from "react-i18next";

import ObservationsBatchEdit from "@/modules/observations/observations-batch-edit";
import { useSidePanel } from "@/modules/side-panel";

export const useObservationsTableBatchEdit = () => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();

  const onBatchEditClick = (observations: ObservationLite[]) => {
    openSidePanel({
      title: t("observation:batchEdit.title"),
      component: <ObservationsBatchEdit observations={observations} />,
    });
  };

  return {
    onBatchEditClick,
  };
};
